import React, { Component } from "react";
import YourAccount from "./YourAccount.jsx";
import UpdateDetailsModal from "./UpdateDetailsModal.jsx";
import axios from "axios";
import serialize from "form-serialize";

export default class YourAccountContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            modalType: 1,
            successMessage: "",
            errorMessage: ""
        };
        this.updateEmail = this.updateEmail.bind(this);
        this.updateName = this.updateName.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleUpdateDetailsSubmit = this.handleUpdateDetailsSubmit.bind(this);
    }

    updateEmail() {
        this.setState({ showModal: true, modalType: 1, errorMessage: "" });
    }

    updateName() {
        this.setState({ showModal: true, modalType: 2, errorMessage: "" });
    }

    updatePassword() {
        this.setState({ showModal: true, modalType: 3, errorMessage: "" });
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    handleUpdateDetailsSubmit(e) {
        e.preventDefault();

        const form = e.target.closest("form");
        axios.post(form.action, serialize(form))
            .then(res => {
                this.setState({ successMessage: res.request.responseText, errorMessage: "" });
                setTimeout(() => {
                    this.setState({ showModal: false, successMessage: "" });
                }, 3000);
            })
            .catch(err => {
                this.setState({ errorMessage: err.request.responseText });
            });
    }

    render() {
        return (
            <YourAccount
                updateEmail={this.updateEmail}
                updateName={this.updateName}
                updatePassword={this.updatePassword}
                currentUser={this.props.currentUser}
            >
                <UpdateDetailsModal
                    handleSubmit={this.handleUpdateDetailsSubmit}
                    successMessage={this.state.successMessage}
                    errorMessage={this.state.errorMessage}
                    show={this.state.showModal}
                    modalType={this.state.modalType}
                    close={this.closeModal}
                    currentUser={this.props.currentUser}
                />
            </YourAccount>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/YourAccountContainer.jsx.erb